import { StringProps } from "./lib/type";

export const uaStrings: StringProps = {
  common: {
    cancel: "Скасувати",
    noData: "Немає інформації",
    choose: "Обрати",
    chose: 'Обрано',
    more: "Детальніше",
    save: "Зберегти",
    revoke: "Скасувати",
  },
  proposalTable: {
    recalculate: "Перерахувати",
    changeCover: "Змінити покриття",
    getToKnowDetailProgram:
      "Ознайомитись з детальним порівнянням програм страхування.",
  },
  orderAgreementModal: {
    sign: 'Підписати',
    confirmAgreement: "Підтвердити договір",
    proposalLink: "Посилання на пропозицію",
    emailInfo:
      "На вказану вами електронну адресу надійшов лист з пропозицією, де ви можете перевірити актуальність усіх даних та ознайомитись із загальними умовами страхування додаткових продуктів, якщо ви їх обирали. Для ознайомлення із зареєстрованою пропозицією ВОСЦПВВНТЗ (Автоцивілка) перейдіть за посиланням нижче.", // Added
  },
  hintCard: {
    cardTitle: "Помічник оформлення полісу",
  },
};
